import { render, staticRenderFns } from "./NeedEditPhds.vue?vue&type=template&id=17d461db&scoped=true&"
import script from "./NeedEditPhds.vue?vue&type=script&lang=js&"
export * from "./NeedEditPhds.vue?vue&type=script&lang=js&"
import style0 from "./NeedEditPhds.vue?vue&type=style&index=0&id=17d461db&prod&lang=css&"
import style1 from "./NeedEditPhds.vue?vue&type=style&index=1&id=17d461db&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d461db",
  null
  
)

export default component.exports